import { memo } from "react";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import { parseUsageShortMessage } from "../utils/fluxmedDefaultTemplateUsage";

export interface MessageDefaultTemplateUsageShortLineProps {
  message: string;
}

const MessageDefaultTemplateUsageShortLine = memo(
  ({ message }: MessageDefaultTemplateUsageShortLineProps) => {
    const theme = useTheme();
    const { description } = parseUsageShortMessage(message);

    return (
      <Stack
        spacing={0.35}
        sx={{
          flex: 1,
          minWidth: 0,
          pl: 2.5,
        }}
      >
        <Stack direction="row" spacing={0.5} alignItems="center">
          <InfoOutlinedIcon
            sx={{ fontSize: 13, color: "text.disabled", flexShrink: 0 }}
          />
          <Typography
            variant="caption"
            color="text.disabled"
            fontWeight={600}
            sx={{ letterSpacing: "0.02em" }}
          >
            Quando é usado
          </Typography>
        </Stack>

        <Typography
          variant="caption"
          color="text.secondary"
          component="div"
          sx={{
            lineHeight: 1.5,
            display: "list-item",
            listStyleType: "disc",
            listStylePosition: "outside",
            marginLeft: 1.75,
            paddingLeft: 0.25,
            "&::marker": {
              color: theme.palette.text.primary,
              fontSize: "0.65rem",
            },
          }}
        >
          {description}
        </Typography>
      </Stack>
    );
  },
);

MessageDefaultTemplateUsageShortLine.displayName =
  "MessageDefaultTemplateUsageShortLine";

export default MessageDefaultTemplateUsageShortLine;
